import { Avatar } from '@assembly-js/design-system';
import { useState } from 'react';

import { isClient, isCompany } from 'src/constants';
import { ContextBarAvatarPopover } from 'src/features/context-bar/ContextBarAvatarPopover';
import { getEntityName, useEntity } from 'src/features/context-bar/utils';
import { getInitials } from 'src/utils/UserUtils';

interface ContextBarAvatarProps {
  className?: string;
  entityType: 'client' | 'company';
  entityId: string;
}

export const ContextBarAvatar = ({
  className,
  entityType,
  entityId,
}: ContextBarAvatarProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const entity = useEntity(entityType, entityId);

  const entityName = getEntityName(entity);
  const avatarFallbackColor = entity?.fields.fallbackColor ?? '#6B7280';
  let avatarSrc = '';
  if (isClient(entity)) {
    avatarSrc = entity.fields.avatarImageUrl ?? '';
  } else if (isCompany(entity)) {
    avatarSrc = entity.fields.avatarImageURL ?? '';
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        className={`${className ?? ''} border-0 bg-transparent p-0 cursor-pointer inline-flex`}
        onClick={handleClick}
        aria-label={`View ${entityName} profile`}
      >
        <Avatar
          src={avatarSrc}
          fallbackColor={avatarFallbackColor}
          variant={entityType === 'client' ? 'circle' : 'rounded'}
          text={getInitials(entityName, { twoLetters: true })}
          size="md"
          alt={entityName}
        />
      </button>
      <ContextBarAvatarPopover
        entityType={entityType}
        entityId={entityId}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      />
    </>
  );
};
